<template>
  <div class="page">
    <el-card shadow="never">
      <div slot="header" class="card-header">
        <span>用户开票</span>
        <el-select v-model="filterStatus" placeholder="状态" clearable style="width: 140px" @change="handleSearch">
          <el-option v-for="opt in statusOptions" :key="opt.value" :label="opt.label" :value="opt.value" />
        </el-select>
      </div>
      <el-table v-loading="loading" :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column prop="userId" label="用户ID" width="90" />
        <el-table-column prop="orderId" label="订单ID" width="90" />
        <el-table-column prop="title" label="抬头" min-width="140" />
        <el-table-column prop="amount" label="金额" width="100" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="{ row }">{{ labelOf(INVOICE_STATUS, row.status) }}</template>
        </el-table-column>
        <el-table-column prop="createdAt" label="申请时间" min-width="160" :formatter="formatTime" />
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.status === 0"
              type="text"
              size="small"
              @click="handleProcess(row)"
            >标记已开票</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        background
        layout="total, prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        :total="total"
        @current-change="handlePageChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getInvoiceList, processInvoice } from '@/api/admin'
import { INVOICE_STATUS, labelOf, optionsOf } from '@/utils/adminConstants'
import listPage from '@/mixins/listPage'

function formatDateTimeStr(value) {
  if (!value) return '-'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return String(value)
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

export default {
  name: 'AdminInvoices',
  mixins: [listPage],
  data() {
    return {
      INVOICE_STATUS,
      filterStatus: null
    }
  },
  computed: {
    statusOptions() {
      return optionsOf(INVOICE_STATUS)
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    labelOf,
    formatTime(row, col, value) {
      return formatDateTimeStr(value)
    },
    fetchList(params) {
      return getInvoiceList({
        ...params,
        status: this.filterStatus != null ? this.filterStatus : undefined
      })
    },
    handleProcess(row) {
      this.$confirm('确认标记为已开票？', '提示', { type: 'warning' }).then(async () => {
        try {
          await processInvoice(row.id, 1)
          this.$message.success('处理成功')
          this.loadList()
        } catch (e) {
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
